import { useSetRecoilState } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { alertDialogAtom } from '@zurich/ui/legacy/recoil';
export function useDeleteDialog({ type, gender = 'female', }) {
    const { t } = useTranslation();
    const setAlertDialog = useSetRecoilState(alertDialogAtom);
    const setDeleteDialog = (props) => {
        setAlertDialog({
            title: t('actions.deleteTitle', {
                type,
            }),
            description: t('actions.deleteDesc', {
                type,
                context: gender,
            }),
            continueText: t('common:button_label.delete'),
            cancelText: t('common:button_label.cancel'),
            ...props,
        });
    };
    return setDeleteDialog;
}
